module.exports = __webpack_public_path__ + "static/media/no-item-found.6f7f0258.png";